import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AddPromotionToCartButtonComponent} from './add-promotion-to-cart-button.component';
import {ButtonModule} from '../button/button.module';
import {TranslateModule} from '@ngx-translate/core';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {LocalizedCurrencyModule} from '@app/presentation/pipes/localized-currency/localized-currency.module';


@NgModule({
  declarations: [
    AddPromotionToCartButtonComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    TranslateModule,
    AngularSvgIconModule,
    LocalizedCurrencyModule
  ],
  exports: [
    AddPromotionToCartButtonComponent
  ]
})
export class AddPromotionToCartButtonModule { }
